import { Story } from '../types/models/Newspaper';
import API from './config';

export function getAll(newspaperId: string, editionId: string) {
  return API.get<{ data: Story[] }>(`/newspapers/${newspaperId}/editions/${editionId}/stories`);
}

export function create(newspaperId: string, editionId: string, params: {
  student_id?: string;
  template_type: string;
  title?: string;
  proposed_by_student?: boolean;
}) {
  return API.post<{ data: Story }>(`/newspapers/${newspaperId}/editions/${editionId}/stories`, params);
}

export function bulkCreate(newspaperId: string, editionId: string, stories: {
  student_id: string;
  template_type: string;
  title?: string;
}[]) {
  return API.post<{ data: Story[] }>(`/newspapers/${newspaperId}/editions/${editionId}/stories/bulk`, { stories });
}

export function update(newspaperId: string, editionId: string, storyId: string, params: {
  template_type?: string;
  title?: string;
  status?: string;
  teacher_approved?: boolean;
  document_id?: string;
}) {
  return API.patch<{ data: Story }>(`/newspapers/${newspaperId}/editions/${editionId}/stories/${storyId}`, params);
}

export function deleteStory(newspaperId: string, editionId: string, storyId: string) {
  return API.delete(`/newspapers/${newspaperId}/editions/${editionId}/stories/${storyId}`);
}

export function getAiSuggestions(params: {
  edition_id: string;
  students: { id: string; name: string }[];
  existing_assignments: { student_name: string; template_type: string }[];
  message: string;
}) {
  return API.post<{ suggestions: AiSuggestion[] }>('/ai/story-assignments', params);
}

export interface AiSuggestion {
  student_id: string;
  student_name: string;
  template_type: string;
  rationale: string;
}
